import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./auth/reducer";
import onboardingReducer from "./onboarding/reducer";
import globalReducer from "./global/reducer";
import plansReducer from "./plans/reducer";
import formCustomizationReducer from "./formCustomization/reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "global", "plans"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  onboarding: onboardingReducer,
  global: globalReducer,
  plans: plansReducer,
  formCustomization: formCustomizationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
export type RootState = ReturnType<typeof rootReducer>;